<template>
<div class="flex overflow-hidden xyz-input justify-between">
    <label class="font-bold" for="">
    	<i :class="label"></i>
    </label>
    <div class="flex wrapper">
        <div class="flex">
            <span>X</span>
            <input :name="inputName+'_x'" type="number" :value="getValue('x')" 
            @input="handleChange">
        </div>
        <div class="flex">
            <span>Y</span>
            <input :name="inputName+'_y'" type="number" :value="getValue('y')" 
            @input="handleChange">
        </div>
        <div class="flex">
            <span>Z</span>
            <input :name="inputName+'_z'" type="number" :value="getValue('z')" 
            @input="handleChange">
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['label', 'inputName', 'handleChange', 'form'],
    methods: {
        getValue(axis){
        const marker_name = 'marker_'+this.inputName;
            switch(axis) {
            case 'x':
            return this.form.general[marker_name][0];
            break;

            case 'y':
            return this.form.general[marker_name][1];
            break;

            case 'z':
            return this.form.general[marker_name][2];
            break;
            }
        }
    }
}
</script>